import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Container, Row, Col, FormGroup, Label, InputGroup, Input, Button, Modal } from "reactstrap";
import Joi from "joi-browser";
import { toastBigError } from "components/utils/toasts";
import { getEvento, saveEvento, uploadFoto } from "services/eventoService";
import Switch from "react-bootstrap-switch";
import FileUploadContainer from "components/fileUploader/fileUploader";
import ReactDatetime from "react-datetime";
import moment from "moment";
import "moment/locale/es.js";
import { Gallery } from "react-grid-gallery";

import { getConfig } from "config/config";

const EventosForm = ({ props, onLoading, onDoneLoading }) => {
  const history = useHistory();
  const location = useLocation();

  const imageSources = [
    require("../../assets/img/page_parallax01.jpg"),
    require("../../assets/img/page_parallax02.jpg"),
    require("../../assets/img/page_parallax03.jpg"),
    require("../../assets/img/page_parallax04.jpg"),
    require("../../assets/img/page_parallax05.jpg"),
    require("../../assets/img/page_parallax06.jpg"),
    require("../../assets/img/page_parallax07.jpg"),
    require("../../assets/img/page_parallax08.jpg"),
    require("../../assets/img/page_parallax09.jpg"),
    require("../../assets/img/page_parallax10.jpg"),
    require("../../assets/img/page_parallax11.jpg"),
    require("../../assets/img/page_parallax12.jpg"),
    require("../../assets/img/page_parallax13.jpg"),
    require("../../assets/img/page_parallax14.jpg"),
  ];
  const images = [
    {
      src: imageSources[0],
      width: 100,
      height: 66,
    },
    {
      src: imageSources[1],
      width: 100,
      height: 66,
    },
    {
      src: imageSources[2],
      width: 100,
      height: 66,
    },
    {
      src: imageSources[3],
      width: 100,
      height: 66,
    },
    {
      src: imageSources[4],
      width: 100,
      height: 66,
    },
    {
      src: imageSources[5],
      width: 100,
      height: 66,
    },
    {
      src: imageSources[6],
      width: 100,
      height: 66,
    },
    {
      src: imageSources[7],
      width: 100,
      height: 66,
    },
    {
      src: imageSources[8],
      width: 100,
      height: 66,
    },
    {
      src: imageSources[9],
      width: 100,
      height: 66,
    },
    {
      src: imageSources[10],
      width: 100,
      height: 66,
    },
    {
      src: imageSources[11],
      width: 100,
      height: 66,
    },
    {
      src: imageSources[12],
      width: 100,
      height: 66,
    },
    {
      src: imageSources[13],
      width: 100,
      height: 66,
    },
  ];
  const hoy = new Date(); // Get current date and time
  const hoyMediodia = new Date(
    hoy.getFullYear(),
    hoy.getMonth(),
    hoy.getDate(),
    12, // Hour for noon
    0, // Minutes
    0 // Seconds
  );
  const [modal, setModal] = useState(false);
  const [fechaEvento, setFechaEvento] = useState(hoyMediodia);
  const [data, setData] = useState({
    _id: "",
    descripcion: "",
    foto: "",
    lugar: "",
    titulo: "",
    background: 0,
    fechayhora: hoyMediodia,
    habilitado: false,
    cuentaregresiva: false,
  });
  const [errors, setErrors] = useState([]);
  const [action, setAction] = useState(location.state?.action ? location.state.action : "");
  const validateForm = true;

  const config = getConfig();

  moment.locale("es", {
    week: {
      dow: 1, // for starrting day from monday
    },
  });

  const filesUrl = config.filesUrl + "/eventos/";

  const preSchema = {
    _id: Joi.string().allow(""),
    descripcion: Joi.string()
      .label("Descripción")
      .required()
      .error((errors) => {
        return errors.map((error) => {
          switch (error.type) {
            case "any.empty":
              return { message: "Debe ingresar una descripción" };
            default:
              return { message: "Debe ingresar una descripción" };
          }
        });
      }),
    lugar: Joi.string().allow(""),
    titulo: Joi.string().allow(""),
    foto: Joi.string().allow(""),
    fechayhora: Joi.date(),
    habilitado: Joi.boolean(),
    background: Joi.number(),
    cuentaregresiva: Joi.boolean(),
  };

  const schema = {
    _id: Joi.string().allow(""),
    descripcion: Joi.string()
      .label("Descripción")
      .required()
      .error((errors) => {
        return errors.map((error) => {
          switch (error.type) {
            case "any.empty":
              return { message: "Debe ingresar una descripción" };
            default:
              return { message: "Debe ingresar una descripción" };
          }
        });
      }),
    foto: Joi.string().allow(""),
    titulo: Joi.string().allow(""),
    lugar: Joi.string()
      .label("Lugar")
      .required()
      .error((errors) => {
        return errors.map((error) => {
          switch (error.type) {
            case "any.empty":
              return { message: "Debe ingresar el lugar del evento" };
            default:
              return { message: "Debe ingresar el lugar del evento" };
          }
        });
      }),
    direccion: Joi.string(),
    fechayhora: Joi.date(),
    habilitado: Joi.boolean(),
    background: Joi.number(),
    cuentaregresiva: Joi.boolean(),
    // requiereConfirmacion: Joi.boolean(),
  };

  const fetchData = async (id) => {
    const record = await getEvento(id);
    mapToViewModel(record);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    const id = props.match.params.id;
    if (!id.includes("nuev")) {
      fetchData(id);
    } else {
      setAction("A");
    }
  }, []);

  const mapToViewModel = (evento) => {
    setData({
      _id: evento._id,
      descripcion: evento.descripcion,
      lugar: evento.lugar,
      direccion: evento.direccion,
      fechayhora: evento.fechayhora,
      foto: evento.foto ? evento.foto : "",
      titulo: evento.titulo,
      background: evento.background,
      habilitado: evento.habilitado,
      cuentaregresiva: evento.cuentaregresiva,
      //   requiereConfirmacion: evento.requiereConfirmacion,
    });
    setFechaEvento(moment(evento.fechayhora));
  };

  const handleChange = (event) => {
    const input = event.currentTarget;
    const inputMode = event.target.inputMode;
    const cacheErrors = { ...errors };
    const cacheData = { ...data };
    if (validateForm) {
      const errorMessage = validateProperty(input, inputMode);
      if (errorMessage) {
        cacheErrors[input.name] = errorMessage;
      } else delete cacheErrors[input.name];
    } else delete cacheErrors[input.name];
    cacheData[input.name] = input.value;
    if (input.type === "checkbox") cacheData[input.name] = input.checked;
    setData(cacheData);
    setErrors(cacheErrors);
  };

  //   const handleChangeSwitch = (component, state) => {
  //     const name = component.props.name;
  //     const value = state;
  //     const cacheData = { ...data };
  //     cacheData[name] = value;
  //     setData(cacheData);
  //   };

  const handleChangeSwitch = (sw) => {
    const cacheData = { ...data };
    if (sw === "habilitado") cacheData["habilitado"] = !cacheData["habilitado"];
    else cacheData["cuentaregresiva"] = !cacheData["cuentaregresiva"];
    setData(cacheData);
  };

  const validateRules = () => {
    return null;
  };

  const validate = () => {
    let errors = {};
    const options = { abortEarly: false };
    if (validateForm) {
      //   var { data } = this.state;
      Object.keys(data).map(function (key, index) {
        if (
          (key.toLowerCase().includes("dni") || key.toLowerCase().includes("documento")) &&
          !key.toLowerCase().includes("tipo")
        ) {
          const valor = data[key];
          const stripped = valor.replaceAll(".", "");
          if (stripped.length === 8) {
            const nuevoValor =
              stripped.substring(0, 2) + "." + stripped.substring(2, 5) + "." + stripped.substring(5, 8);
            data[key] = nuevoValor;
          }
          if (stripped.length === 7) {
            const nuevoValor =
              stripped.substring(0, 1) + "." + stripped.substring(1, 4) + "." + stripped.substring(4, 7);
            data[key] = nuevoValor;
          }
        }
        if (typeof data[key] === "object" && data[key] && data[key].value && typeof data[key].value === "string") {
          data[key] = data[key].value;
        }
      });
      let { error } = Joi.validate(data, data._id ? schema : preSchema, options);
      if (!error) {
        error = validateRules();
        if (!error) {
          Object.keys(data).map(function (key, index) {
            if (typeof data[key] === "object" && data[key] && data[key].value) data[key] = data[key].value;
          });
          return null;
        }
        error.map((error) => {
          toastBigError(error.message, 2500);
          return (errors[error.path] = error.message);
        });
        return errors;
      } else {
        error.details.map((validationError) => {
          return (errors[validationError.path[0]] = validationError.message);
        });
        return errors;
      }
    } else return null;
  };

  const validateProperty = (input, inputMode) => {
    let { name, value } = input;
    if (inputMode === "numeric") {
      const index = value.indexOf(" ");
      value = parseFloat(value.substr(value.indexOf(" ") + 1));
    }
    const object = { [name]: value };
    const checkSchema = { [name]: data._id ? schema[name] : preSchema[name] };
    const { error } = Joi.validate(object, checkSchema);
    return error ? error.details[0].message : null;
  };

  const prepareData = () => {
    // const datos = { ...data };
    // console.log("prepareData");
    // console.log(datos);
    // if (moment.isMoment(datos.fechayhora)) datos.fechayhora = datos.fechayhora.toDate();
    // console.log(datos);
    // setData(datos);
  };

  const handleSubmit = async (event) => {
    prepareData();
    if (event) event.preventDefault();
    // console.log("data");
    // console.log(data);
    const checkErrors = validate();
    if (checkErrors) {
      setErrors(checkErrors);
      return;
    }
    doSubmit();
  };

  const doSubmit = async () => {
    const datos = { ...data };
    const newId = await saveEvento(data);
    if (data._id) history.push({ pathname: "/eventos" });
    else {
      datos._id = newId;
      //   if (!moment.isMoment(datos.fechayhora)) datos.fechayhora = moment(datos.fechayhora);
      setData(datos);
    }
  };

  const goBack = () => {
    history.goBack();
  };

  const handleChangeTime = (event) => {
    const cacheData = { ...data };
    cacheData.fechayhora = event.toDate();
    setData(cacheData);
    setFechaEvento(event);
  };

  const uploadImage = async (uploadData) => {
    const datos = { ...data };
    const filename = await uploadFoto(datos._id, uploadData, datos.foto);
    if (filename) {
      datos.foto = filename;
      setData(datos);
    }
  };

  const handleSelectBack = () => {
    if (action !== "C") setModal(true);
  };

  const handleSelectImage = (item) => {
    const cacheData = { ...data };
    cacheData.background = item;
    setData(cacheData);
    setModal(false);
  };

  return (
    <>
      <Container className="wrapper">
        <form onSubmit={handleSubmit}>
          <h3 className="mt-4 mb-2">Detalles del Evento</h3>
          <Row className="mt-4 mb-2 align-items-center">
            <Col sm="12">
              <InputGroup className={(errors["descripcion"] ? "has-danger" : "") + " align-items-center"}>
                <h6>
                  <Label className="mb-0" style={{ marginRight: "20px" }}>
                    Descripción
                  </Label>
                </h6>
                <Input
                  autoFocus
                  disabled={action === "C"}
                  className={errors["descripcion"] ? "text-control-danger" : ""}
                  placeholder="Descripción del Evento"
                  type="text"
                  name="descripcion"
                  value={data.descripcion}
                  onChange={(event) => handleChange(event)}
                />
                {errors["descripcion"] ? <div className="form-control-feedback">{errors["descripcion"]}</div> : ""}
              </InputGroup>
            </Col>
          </Row>
          {data._id && (
            <>
              <Row className="mb-2 align-items-center">
                <Col sm="12" md="6" className="mb-sm-2 mb-md-0">
                  <InputGroup className={(errors["titulo"] ? "has-danger" : "") + " align-items-center"}>
                    <h6>
                      <Label className="mb-0" style={{ marginRight: "20px" }}>
                        Lugar
                      </Label>
                    </h6>
                    <Input
                      autoFocus
                      disabled={action === "C"}
                      className={errors["lugar"] ? "text-control-danger" : ""}
                      placeholder="Lugar del Evento"
                      type="text"
                      name="lugar"
                      value={data.lugar}
                      onChange={(event) => handleChange(event)}
                    />
                    {errors["lugar"] ? <div className="form-control-feedback">{errors["lugar"]}</div> : ""}
                  </InputGroup>
                </Col>
                <Col sm="12" md="6" className="mb-sm-2 mb-md-0">
                  <InputGroup className={(errors["titulo"] ? "has-danger" : "") + " align-items-center"}>
                    <h6>
                      <Label className="mb-0" style={{ marginRight: "20px" }}>
                        Hora
                      </Label>
                    </h6>

                    <ReactDatetime
                      //   dateFormat={false}
                      timeConstraints={{ minutes: { step: 5 } }}
                      value={fechaEvento}
                      onChange={(event) => handleChangeTime(event)}
                      inputProps={{
                        className: "form-control",
                      }}
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col sm="12" md="12" className="mb-sm-2 mb-md-0">
                  <InputGroup className="align-items-center">
                    <h6>
                      <Label className="mb-0 mr-2">Direccion</Label>
                    </h6>
                    <Input
                      autoFocus
                      disabled={action === "C"}
                      //   className={errors["lugar"] ? "text-control-danger" : ""}
                      placeholder=""
                      type="text"
                      name="direccion"
                      value={data.direccion}
                      onChange={(event) => handleChange(event)}
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col sm="12" md="6" className="mb-sm-2 mb-md-0">
                  <InputGroup className="align-items-center">
                    <h6>
                      <Label className="mb-0 mr-2">Título Landing Page</Label>
                    </h6>
                    <Input
                      autoFocus
                      disabled={action === "C"}
                      //   className={errors["lugar"] ? "text-control-danger" : ""}
                      placeholder=""
                      type="text"
                      name="titulo"
                      value={data.titulo}
                      onChange={(event) => handleChange(event)}
                    />
                  </InputGroup>
                </Col>
                <Col sm="12" md="6" className="mb-sm-2 mb-md-0">
                  <InputGroup className="align-items-center">
                    <h6>
                      <Label className="mb-0 mr-2">Cuenta Regresiva</Label>
                    </h6>
                    <Switch
                      disabled={action === "C"}
                      onColor="success"
                      offColor="default"
                      onText=""
                      offText=""
                      name="cuentaregresiva"
                      value={data.cuentaregresiva}
                      onChange={() => handleChangeSwitch("cuentaregresiva")}
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col sm="12" md="6">
                  <InputGroup className="align-items-center">
                    <h6>
                      <Label className="mb-0 mr-2">Habilitar Invitaciones</Label>
                    </h6>
                    <Switch
                      disabled={action === "C"}
                      onColor="success"
                      offColor="default"
                      onText=""
                      offText=""
                      name="habilitado"
                      value={data.habilitado}
                      onChange={() => handleChangeSwitch("habilitado")}
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col sm="2">
                  <h6>
                    <Label className="mb-0 mr-2">Fondo</Label>
                    <img
                      alt="..."
                      className="img-rounded img-tweet-link img-responsive"
                      src={imageSources[data.background]}
                      onClick={handleSelectBack}
                    />
                  </h6>
                </Col>
              </Row>
            </>
          )}

          {/* {data._id && (
            <>
              <Row>
                <Col sm="12">
                  <Row className="ml-0">
                    <h5 className="mr-2">Requiere Confirmación</h5>
                    <Switch onColor="success" onText="" offText="" disabled={action === "C"} offColor="default" name="requiereConfirmacion" value={data.requiereConfirmacion} onChange={(component, state) => handleChangeSwitch(component, state)} />
                  </Row>
                </Col>
              </Row>
              <Row className="mt-2 mb-2">
                <Col sm="6">
                  <FileUploadContainer style={{ height: "600px" }} onUpload={(files) => uploadImage(files)} accept={"image/jpeg, image/png"} minSize={1024} maxSize={3072000} background={data.foto ? filesUrl + data.foto : ""} />
                </Col>
              </Row>
            </>
          )} */}
          <Row className="justify-content-center mt-3">
            {action !== "C" ? (
              <Button outline className="btn-round mr-1" color="success" type="button" onClick={handleSubmit}>
                {data._id ? "Guardar" : "Continuar"}
              </Button>
            ) : (
              ""
            )}
            {data._id && (
              <Button outline className="btn-round mr-1" color="danger" type="button" onClick={goBack}>
                {action === "C" ? "Vovler" : "Cancelar"}
              </Button>
            )}
          </Row>
        </form>
      </Container>

      <Modal isOpen={modal} backdrop="static" toggle={() => setModal(false)}>
        <div className="modal-header no-border-header">
          <button className="close" type="button" onClick={() => setModal(false)}>
            ×
          </button>
        </div>
        <div
          className="modal-body"
          style={{
            paddingLeft: "10px",
            paddingRight: "10px",
            // maxHeight: "60vh",
            overflowY: "auto",
          }}
        >
          <Gallery images={images} rowHeight={90} onSelect={(item) => handleSelectImage(item)} />
        </div>
      </Modal>
    </>
  );
};

export default EventosForm;
